import { css } from 'styled-components/macro';

export default {
  mediaBlock: css`
    display: flex;
    flex-direction: column;
    width: 100%;

    .mediaBlockContent {
      & > * {
        margin: 0 auto !important;
      }
    }
  `,
};
